import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logoutCurrentStaff } from '../../logout';
import { staffService } from '../../services';
import { useBusinessStore, useStaffSessionStore } from '../../store';
import { REGISTER_EVENTS } from '../../types';
import { useCustomerAnalytics } from '../use-customer-analytics';

export const useAutoStaffLogout = () => {
    const { businessInfo } = useBusinessStore();
    const businessId = businessInfo?.businessId;
    const navigate = useNavigate();
    const { sendMixpanelEvent } = useCustomerAnalytics();

    useEffect(() => {
        if (!businessId) {
            return;
        }

        const handleStaffChange = (incomingId: string) => {
            const currentStaffId = useStaffSessionStore.getState().staffId;

            if (!currentStaffId || currentStaffId !== incomingId) {
                return;
            }

            logoutCurrentStaff(navigate);
        };

        const unsubscribePinChange = staffService.subscribeToPinChange(
            (incomingId) => {
                sendMixpanelEvent({
                    eventName: REGISTER_EVENTS.LOGOUT.STAFF_LOGOUT,
                    properties: { reason: 'pin_changed', staffId: incomingId },
                });
                handleStaffChange(incomingId);
            },
        );
        const unsubscribeDeletion = staffService.subscribeToDeletion(
            (incomingId) => {
                sendMixpanelEvent({
                    eventName: REGISTER_EVENTS.LOGOUT.STAFF_LOGOUT,
                    properties: {
                        reason: 'staff_deleted',
                        staffId: incomingId,
                    },
                });
                handleStaffChange(incomingId);
            },
        );

        return () => {
            unsubscribePinChange();
            unsubscribeDeletion();
        };
    }, [businessId, sendMixpanelEvent, navigate]);
};
